"use client"

import { X } from "lucide-react"
import { ComponentProps, PropsWithChildren } from "react"
import React from "react"
import { Drawer as DrawerPrimitives } from "vaul"

import { Button } from "../Button/button"
import * as drawerStyle from "./drawer.styled"

const Drawer = ({
  children,
  ...props
}: PropsWithChildren<ComponentProps<typeof DrawerPrimitives.Root>>) => (
  <DrawerPrimitives.Root {...props}>{children}</DrawerPrimitives.Root>
)

const DrawerTrigger = ({
  children,
  ...props
}: PropsWithChildren<ComponentProps<typeof DrawerPrimitives.Trigger>>) => (
  <DrawerPrimitives.Trigger {...props} asChild>
    {children}
  </DrawerPrimitives.Trigger>
)

const DrawerFooter = ({
  children,
  className,
  ...props
}: PropsWithChildren<ComponentProps<"div">>) => (
  <div className={drawerStyle.drawerFooter(className)} {...props}>
    {children}
  </div>
)

const DrawerClose = ({
  children,
  onClose,
  ...props
}: PropsWithChildren<ComponentProps<typeof DrawerPrimitives.Close> & { onClose: () => void }>) => (
  <DrawerPrimitives.Close {...props} onPointerDown={onClose} asChild>
    {children}
  </DrawerPrimitives.Close>
)

const DrawerTitle = ({
  children,
  className,
  ...props
}: PropsWithChildren<ComponentProps<typeof DrawerPrimitives.Title>>) => (
  <DrawerPrimitives.Title className={drawerStyle.drawerTitle(className)} {...props}>
    {children}
  </DrawerPrimitives.Title>
)

const DrawerDescription = ({
  children,
  className,
  ...props
}: PropsWithChildren<ComponentProps<typeof DrawerPrimitives.Description>>) => (
  <DrawerPrimitives.Description className={drawerStyle.drawerDescription(className)} {...props}>
    {children}
  </DrawerPrimitives.Description>
)

const DrawerTextContainer = ({ children }: PropsWithChildren<ComponentProps<"div">>) => (
  <div className={drawerStyle.drawerTextContainer}>{children}</div>
)

const DrawerContent = ({
  children,
  className,
  onClose,
  ...props
}: PropsWithChildren<ComponentProps<"div"> & { onClose: () => void }>) => {
  return (
    <>
      <DrawerPrimitives.Overlay className={drawerStyle.drawerOverlay} />
      <DrawerPrimitives.Portal>
        <DrawerPrimitives.Content className={drawerStyle.drawerContent}>
          <div className={drawerStyle.drawer}>
            <div className={drawerStyle.drawerHandle} />
            <div className={drawerStyle.drawerWrapper}>
              <DrawerClose className={drawerStyle.drawerClose} onClose={onClose}>
                <Button size="sm" variant="tertiary" shape="circle">
                  <X className={drawerStyle.drawerCloseIcon} />
                </Button>
              </DrawerClose>
              <div className={drawerStyle.drawerInner(className)} {...props}>
                {children}
              </div>
            </div>
          </div>
        </DrawerPrimitives.Content>
      </DrawerPrimitives.Portal>
    </>
  )
}

export {
  Drawer,
  DrawerTrigger,
  DrawerContent,
  DrawerTitle,
  DrawerDescription,
  DrawerTextContainer,
  DrawerFooter,
  DrawerClose,
}
